module.exports = __webpack_public_path__ + "img/empty.4f91e9d8.svg";